<script setup>
import { ref, computed, watch, nextTick } from "vue";
import { useI18n } from 'vue-i18n';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import CreateOrder from 'dashboard/components-next/Order/CreateOrder.vue';
import OrderList from 'dashboard/components-next/Order/OrderList.vue';
import UserInfo from 'dashboard/components-next/Order/UserInfo.vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { emitter } from 'shared/helpers/mitt';
import { useEmitter } from 'dashboard/composables/emitter';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
  inboxId: {
    type: Number,
    default: undefined,
  },
});

const store = useStore();
const currentChat = useMapGetter('getSelectedChat');
const contactGetter = useMapGetter('contacts/getContact');
const contactId = computed(() => currentChat.value.meta?.sender?.id);
const contact = computed(() => contactGetter.value(contactId.value));

const conversationId = computed(() => props.conversationId);

const activeTab = ref('create');

const ORDER_TABS_OPTIONS = [
  { key: 'New', value: 'create' },
  { key: 'History', value: 'list' },
  { key: 'User', value: 'userinfo' },
];

const tabs = computed(() => {
  return ORDER_TABS_OPTIONS.map(tab => ({
    label: tab.key,
    value: tab.value,
  }));
});

const activeTabIndex = computed(() => {
  return ORDER_TABS_OPTIONS.findIndex(v => v.value === activeTab.value);
});

const handleTabChange = tab => {
  activeTab.value = tab.value;
};

const handleOrderCreated = (order) => {
  activeTab.value = 'list';
};

useEmitter('createGiftCardWithdraw', message => {
  activeTab.value = 'list';
  nextTick(() => {
    emitter.emit('doGiftCardWithdraw', message);
  });
});
useEmitter('messageForOrder', message => {
  activeTab.value = 'create';
});
useEmitter('createGiftCardOrder', message => {
  activeTab.value = 'create';
});
</script>

<template>
  <div
    class="flex flex-col justify-start flex-1 h-full m-0 overflow-auto bg-n-background pt-2 px-2"
  >
    <TabBar
      :tabs="tabs"
      :initial-active-tab="activeTabIndex"
      class="w-full [&>button]:w-full bg-n-alpha-black2"
      @tab-changed="handleTabChange"
    />

    <CreateOrder
      v-if="activeTab === 'create'"
      :contact="contact"
      :current-chat="currentChat"
      @created="handleOrderCreated"
    />
    <OrderList v-if="activeTab === 'list'" :current-chat="currentChat" />
    <UserInfo v-if="activeTab === 'userinfo'" :current-chat="currentChat" />
  </div>
</template>
